import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './_assets/scss/main.scss';
import { useRouting, useLocalStorage } from '@rad/hooks';
import { NotificationsProvider } from '@rad/contexts/notifications';
import Input from '@rad/components/inputs/input';
import { login } from './types';
import Measure from './screens/measure';
import Scorecards from './screens/scorecards';
import Scorecard from './screens/scorecard';
import ScorecardMeasure from './screens/scorecard-measure';
import MeasureRequest from './screens/measure-request';
import User from './screens/user';
import Admin from './screens/admin';
import AuditLog from './screens/audit-log';
const routes = (token) => [
    {
        'route': [],
        'render': () => _jsx(Scorecards, {}),
    },
    {
        'route': 'measures/request'.split('/'),
        'render': () => _jsx(MeasureRequest, {}),
    },
    {
        'route': 'scorecards/new'.split('/'),
        'render': () => _jsx(Scorecard, { id: null }),
    },
    {
        'route': 'scorecards/$scorecard_id'.split('/'),
        'render': ({ scorecard_id }) => _jsx(Scorecard, { id: scorecard_id }),
    },
    {
        'route': 'scorecards/$scorecard_id/edit'.split('/'),
        'render': ({ scorecard_id }) => _jsx(Scorecard, { id: scorecard_id, edit: true }),
    },
    {
        'route': 'scorecards/$scorecard_id/measures/new'.split('/'),
        'render': ({ scorecard_id }) => _jsx(ScorecardMeasure, { scorecard_id: scorecard_id }),
    },
    // {
    //   'route':'scorecards/$scorecard_id/measures/$measure_id'.split('/'),
    //   'render':({ scorecard_id,measure_id }) => <ScorecardMeasure scorecard_id={scorecard_id} id={measure_id}/>,
    // },
    {
        'route': 'scorecards/$scorecard_id/measures/$measure_id/edit'.split('/'),
        'render': ({ scorecard_id, measure_id }) => _jsx(ScorecardMeasure, { scorecard_id: scorecard_id, id: measure_id, edit: true }),
    },
    ...(token?.is_admin ? [
        {
            'route': 'admin'.split('/'),
            'render': () => _jsx(Admin, {})
        },
        {
            'route': 'admin/$tab'.split('/'),
            'render': ({ tab }) => _jsx(Admin, { tab: tab })
        },
        {
            'route': 'audit-log/$kind/$id'.split('/'),
            'render': ({ kind, id }) => _jsx(AuditLog, { kind: kind, id: id })
        },
        {
            'route': 'measures/new'.split('/'),
            'render': () => _jsx(Measure, {}),
        },
        {
            'route': 'measures/$measure_id/edit'.split('/'),
            'render': ({ measure_id }) => _jsx(Measure, { id: measure_id, edit: true }),
        },
    ] : []),
    ...(token?.is_super_admin ? [
        {
            'route': 'users/new'.split('/'),
            'render': ({ scorecard_id, measure_id }) => _jsx(User, {}),
        },
        {
            'route': 'users/$user_id'.split('/'),
            'render': ({ user_id }) => _jsx(User, { id: user_id }),
        },
    ] : []),
];
const App = () => {
    const [token, setToken] = useLocalStorage('token');
    const [stateEmail, setEmail] = React.useState('');
    const [stateErrors, setErrors] = React.useState();
    const [stateSubmitting, setSubmitting] = React.useState(false);
    const [routeCurrent, navigate] = useRouting();
    const submitLogin = async () => {
        if (stateSubmitting) {
            return;
        }
        setSubmitting(true);
        try {
            const [valid, result] = await login(stateEmail);
            if (valid) {
                setToken(result);
                navigate(result.is_admin ? '#/admin' : '#/');
            }
            else {
                setErrors(result);
            }
        }
        finally {
            setSubmitting(false);
        }
    };
    if (token === null) {
        return _jsx(_Fragment, { children: _jsxs("div", { className: "text-center", children: [_jsx("h1", { children: "Log In" }), _jsx("br", {}), _jsx("form", { onSubmit: (e) => {
                            e.preventDefault();
                            submitLogin();
                        }, children: _jsxs("fieldset", { disabled: stateSubmitting, children: [_jsx(Input, { kind: "text", label: "Email", value: stateEmail, onChange: setEmail, required: true, invalid: stateErrors?.filter((x) => x.field === 'email').map((x) => x.message) }), _jsx("button", { type: "submit", className: "btn btn-primary mt-3", disabled: stateSubmitting, children: stateSubmitting ? 'Logging In...' : 'Log In' })] }) })] }) });
    }
    else {
        const routeMatched = routes(token).map((x) => ((y) => y ? [x, y] : null)(routeCurrent.ismatch(x.route))).find((x) => !!x);
        return _jsx(_Fragment, { children: routeMatched?.[0].render(routeMatched?.[1]) || _jsx("h1", { className: "text-center", children: "NOT FOUND" }) });
    }
};
ReactDOM.createRoot(document.getElementById('root')).render(_jsx(React.StrictMode, { children: _jsx(NotificationsProvider, { children: _jsx(App, {}) }) }));
